import React, { useContext } from 'react';
import styled from 'styled-components';
import { Container } from '@mui/material';
import SiteHeader from '../Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const OnboardingLeftLayout = () => {
  return (
    <Wrapper>
      <div className="signup-status">
        <div className="step completed" id="step1">
          <div className="circle">
            <span className="checkmark">
              <FontAwesomeIcon icon={faCheck} color="#fff" />
            </span>
          </div>
          <p>Logged In</p>
        </div>
        <div className="line"></div>
        <div className="step inprogress" id="step2">
          <div className="circle">
            <span className="num">2</span>
            <span className="checkmark">
              <FontAwesomeIcon icon={faCheck} color="#fff" />
            </span>
          </div>
          <p>Basic Details</p>
        </div>
        <div className="line"></div>
        <div className="step disabled" id="step3">
          <div className="circle">
            <span className="num">3</span>
            <span className="checkmark">
              <FontAwesomeIcon icon={faCheck} color="#fff" />
            </span>
          </div>
          <p>Complete KYC</p>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.aside`
  .signup-status {
    background-color: #d8effa;
    border-radius: 10px;
    padding: 20px;
    display: block;
    align-items: left;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  .step {
    text-align: left;
    flex: 1;
    position: relative;
    display: flex;
    gap: 0 10px;
    filter: brightness(0.8);
    .circle {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 2px solid transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      color: #b3bac5;
      background-color: #fff;
      line-height: 40px;
      margin: 0;
      .checkmark {
        display: none;
      }
      .num {
        display: block;
      }
    }
    // &:last-child {
    //   .circle {
    //     &::before,
    //     &:after {
    //       display: none;
    //     }
    //   }
    // }
  }

  .step.completed .circle {
    background: #36b37e url('../images/check_icon.png') no-repeat bottom left;
    background-position: center;
    color: #fff;
    font-size: 14px;
    font-weight: 400;
    .num {
      display: none;
    }
    .checkmark {
      display: block;
    }
  }

  .step.completed .checkmark {
    font-size: 16px;
  }

  .step.active .circle {
    background-color: #4caf50;
    color: #fff;
  }

  .step.inprogress .circle {
    background-color: #fff;
    border-color: #d8effa;
    color: #36b37e;
  }
  .step.inprogress {
    filter: brightness(1);
    p {
      font-weight: 600;
    }
  }
  .step.completed {
    filter: brightness(1);
  }

  .step p {
    margin-top: 10px;
    font-size: 14px;
    color: #333;
  }

  .line {
    width: 2px;
    height: 40px;
    background-color: #ccc;
    margin: 4px 19px;
  }

  .step.completed + .line {
    background-color: #4caf50;
  }
  @media all and (max-width: 768px) {
    .signup-status {
      width: -webkit-fill-available;
      display: flex;
      justify-content: space-between;
      padding: 20px 8px;
      align-items: center;
      margin: auto;
      background: transparent;
      box-shadow: none;
    }
    .step {
      display: block;
      margin: auto;
      text-align: center;
      width: 100%;
      position: relative;
      .circle {
        display: inline-block;

        &::before,
        &:after {
          position: absolute;
          content: '';
          z-index: -1;
          top: 23px;
          right: 0px;
          height: 3px;
          width: 100%;
          background: #4caf50;
        }
      }
      &#step3 {
        .circle {
          &::after {
            display: none !important;
          }
          &::before {
            left: 0;
            right: unset;
            background: #4caf50;
            opacity: 1;
            width: 50%;
          }
        }
        &.disabled {
          .circle {
            &::before {
              left: 0;
              right: unset;
              background: #a8b3bc;
              opacity: 0.8;
              width: 50%;
            }
          }
        }
      }
      &.inprogress {
        .circle {
          &::after {
            background: #a8b3bc;
            opacity: 0.8;
            width: 50%;
          }
        }
      }
      &#step1 {
        .circle {
          &::before,
          &:after {
            width: 50%;
          }
        }
      }
    }
    .line {
      display: none;
    }
  }
`;

export default OnboardingLeftLayout;
